/* eslint-disable prefer-const */
import moment from 'moment';
import * as ELD_CONSTANTS from '../constants/ELDConstants';
import { getTimerPercentage } from './timeHelper';

const takeFirst = (array, size) => array?.slice(0, size);

const sum = arrayOfInts => arrayOfInts?.reduce((acc, a) => acc + a, 0) || 0;

const sortCycleObject = cycleObject => {
  if (!cycleObject) return [];
  return Object.keys(cycleObject)
    .sort((a, b) => moment(b).valueOf() - moment(a).valueOf())
    .reduce((acc, key) => {
      return [...acc, cycleObject[key]];
    }, []);
};

export const getCycleTomorrowData = state => {
  const ruleset = state.ruleset;
  let cycleWindows = [];
  let cycleTimerMaxValue = 0;
  let cycleDays = 0;
  if (ruleset === ELD_CONSTANTS.US_ELD_STANDARD) {
    if (!state.cycleWindow) return {};
    cycleTimerMaxValue = 70 * 3600000; // 70 hours in ms.
    cycleDays = 8;
    // add check for undefined
    cycleWindows = JSON.parse(state.cycleWindow);
  } else if (ruleset === ELD_CONSTANTS.TEXAS_70_HOUR) {
    if (!state.cycleWindow) return {};
    cycleTimerMaxValue = 70 * 3600000; // 70 hours in ms.
    cycleDays = 7;
    cycleWindows = JSON.parse(state.cycleWindow);
  } else if (ruleset === ELD_CONSTANTS.SHORT_HAUL) {
    return {}; // This ruleset doesn't have a cycle timer, so we can short circuit.
  } else if (ruleset === ELD_CONSTANTS.SHORT_HAUL_PASSENGER) {
    return {}; // This ruleset doesn't have a cycle timer, so we can short circuit.
  } else {
    // This is not one of our legacy rulesets, so use the new ruleset system + state snapshot
    const cycleTimer =
      state.reducedStateSnapshot?.cycleRegulations &&
      state.reducedStateSnapshot.cycleRegulations[0];

    if (!cycleTimer) {
      return {}; // This ruleset doesn't have a cycle timer, so we can short circuit.
    }
    cycleTimerMaxValue = cycleTimer.ceiling;
    cycleDays = cycleTimer.length;

    const unsortedWindows = cycleTimer.cycle;
    cycleWindows = sortCycleObject(unsortedWindows);
  }
  // Trim off any excess days.
  const trimmedWindow = takeFirst(cycleWindows, cycleDays);
  const oldestWindow = trimmedWindow?.[cycleDays - 1] || 0;

  const cycleWorked = sum(trimmedWindow);
  const cycleTomorrow = cycleTimerMaxValue - (cycleWorked - oldestWindow);
  return { cycleWorked, cycleTomorrow };
};

export const getCycleData = cycleRegulation => {
  if (!cycleRegulation) return {};
  const length = cycleRegulation?.length;
  const ceiling = cycleRegulation?.ceiling;
  const current = cycleRegulation?.current;

  // Trim off any excess days.
  const cycleWindows = sortCycleObject(cycleRegulation?.cycle);

  const trimmedWindow = takeFirst(cycleWindows, length);
  const oldestWindow = trimmedWindow?.[length - 1] || 0;

  const cycleTomorrow = ceiling - (current - oldestWindow);

  let time = ceiling - current;
  time = time < 0 ? 0 : time;
  const cycleTimerPercentage = getTimerPercentage(current, ceiling);

  return {
    cycleTomorrowTimer: cycleTomorrow,
    cycleWorkedTimer: cycleRegulation.current,
    cycleTimer: time,
    cycleTimerPercentage,
  };
};

export const convertISOTimeToHours = (isoString, timezone) => {
  return moment.tz(isoString, timezone).format('hh:mm A');
};
